import { AiSuggestionsResponse } from 'types/aiSuggestions';

import { api } from './instance';

export const fetchAiSuggestions = async (itemId: string) => {
  const { data } = await api.get<AiSuggestionsResponse>(
    `/ai-suggestions/${itemId}`,
  );
  return data?.item;
};
